import React from 'react';
import { Badge, Button, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import useMobile from 'services/Hooks/useMobile';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import { useApprovalNotification } from 'services/Data/NotificationService';
import { useSelector } from 'react-redux';
import { getDealerPortalHeaderButtonSx, getDealerPortalStateDisplay } from 'services/Utilities/dealerPortalStateUtils';

const SupportButton = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const accountReducer = useSelector(state => state.AccountReducer);
  const portalStateDisplay = getDealerPortalStateDisplay(t);
  const buttonSx = getDealerPortalHeaderButtonSx(theme, portalStateDisplay.isNonProduction);

  const { data: notification } = useApprovalNotification(accountReducer.isLoggedIn);

  const isMobile = useMobile();

  return (
    <React.Fragment>
      <Badge badgeContent={notification?.supportChatHasNotifications || null} color="secondary">
        <Button
          variant="contained"
          sx={buttonSx}
          endIcon={<ApplicationIcons.Support />}
          component={NavLink}
          to={'/dealer/support-chats'}>
          <Typography variant="h4">{isMobile ? '' : t('support')}</Typography>
        </Button>
      </Badge>
    </React.Fragment>
  );
};

export default SupportButton;
